import {
  getFirestore,
  doc,
  deleteDoc,
  query,
  where,
  getDoc,
  getDocs,
  setDoc,
  updateDoc,
  increment,
  collection,
  deleteField,
} from "firebase/firestore";
import encryptor from "../utils/encryptor";
import IDGenerator from "../utils/IDGenerator";
import { app } from "./FBConfig";

const db = getFirestore(app);
export const signInAdmin = async ({ username, psw }) => {
  const adminCredRef = doc(db, "admin/authCred");
  const { username: adminU, psw: adminP } = (await getDoc(adminCredRef)).data();

  const password = encryptor.decrypt(adminP);

  if (username === adminU && psw === password) return true;

  return false;
};

export const signInStaff = async ({ username, psw }) => {
  const q = query(collection(db, "staff"), where("username", "==", username));

  const querySnapshot = await getDocs(q);
  const docSnapshot = querySnapshot.docs[0];
  if (docSnapshot.exists && psw === username) {
    const { name, class: className } = docSnapshot.data();
    return { name, className, id: docSnapshot.id };
  }

  return null;
};

export const addNewStaff = async ({ name, role }) => {
  const nameArr = name.split(" "),
    username = (nameArr[1] + nameArr[2]).toLowerCase();
  await setDoc(doc(collection(db, "staff")), { name, username, role });
};

export const deleteStaff = async (id) => {
  await deleteDoc(doc(db, `staff/${id}`));
};
export const updateStaff = async (newName, staffId) => {
  const nameArr = newName.split(" "),
    username = (nameArr[1] + nameArr[2]).toLowerCase();
  try {
    const staffRef = doc(db, `staff/${staffId}`);

    await updateDoc(staffRef, {
      name: newName,
      username,
    });
  } catch (error) {
    throw new Error("There is an error");
  }
};

export const addNewClass = async ({ name }) => {
  await setDoc(doc(collection(db, "class")), { name });
};

export const deleteClass = async (id) => {
  await deleteDoc(doc(db, `class/${id}`));
};

export const getClassEntries = async () => {
  const docsSnapshot = await getDocs(collection(db, "class")),
    classes = docsSnapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id }));

  return classes;
};

export const getStaffEntries = async () => {
  const docsSnapshot = await getDocs(collection(db, "staff")),
    staff = docsSnapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id }));

  return staff;
};

export const assignClassToTeacher = async (teacherId, className) => {
  const teacherRef = doc(db, "staff", teacherId);

  await updateDoc(teacherRef, {
    class: className,
    pupils: [],
  });
};

export const addPupils = async ({ name, className }) => {
  const noStudentsRef = doc(db, "admin/students");
  const { noOfStudents } = (await getDoc(noStudentsRef)).data();

  const pupilID = `POMS/21/${(noOfStudents + 1).toString().padStart(4, 0)}`;

  const pupilData = {
    name,
    className,
    pupilID,
    result: [],
  };

  const id = IDGenerator(20);
  await setDoc(doc(db, `pupils/${id}`), pupilData);

  await updateDoc(noStudentsRef, {
    noOfStudents: increment(1),
  });

  const q = query(collection(db, "class"), where("name", "==", className));
  const querySnapshot = await getDocs(q);
  const classID = querySnapshot.docs[0].id;
  await updateDoc(doc(db, `class/${classID}`), {
    [`pupils.${(noOfStudents + 1).toString().padStart(4, 0)}`]: {
      id,
      name,
      pupilID,
    },
  });
};

export const deletePupils = async ({ id, className, studYear }) => {
  const noStudentsRef = doc(db, "admin/students");

  await deleteDoc(doc(db, `pupils/${id}`));

  await updateDoc(noStudentsRef, {
    noOfStudents: increment(-1),
  });

  const q = query(collection(db, "class"), where("name", "==", className));
  const querySnapshot = await getDocs(q);
  const classID = querySnapshot.docs[0].id;
  await updateDoc(doc(db, `class/${classID}`), {
    [`pupils.${studYear}`]: deleteField(),
  });
};

export const getPupils = async (className) => {
  try {
    const qPupils = query(
      collection(db, "pupils"),
      where("className", "==", className)
    );
    const querySnapshot = await getDocs(qPupils);
    const pupilsData = querySnapshot.docs.map((doc) => ({
      ...doc.data(),
      id: doc.id,
    }));

    return pupilsData;
  } catch (error) {
    throw new Error(error);
  }
};

export const uploadResult = async (result, pupilID) => {
  try {
    const pupilRef = doc(db, `pupils/${pupilID}`);

    await updateDoc(pupilRef, {
      "result1-2": result,
    });
  } catch (error) {
    throw new Error("There is an error");
  }
};

export const uploadReportData = async (reportData, pupilID) => {
  try {
    const pupilRef = doc(db, `pupils/${pupilID}`);

    await updateDoc(pupilRef, {
      "reportData1-2": reportData,
    });
  } catch (error) {
    throw new Error("There is an error");
  }
};

export const updateStudentsData = async (reportData, pupilID) => {
  // const noStudentsRef = doc(db, "admin/students");

  // await updateDoc(noStudentsRef, {
  //   noOfStudents: increment(-1),
  // });

  const q = query(
    collection(db, "pupils"),
    where("className", "==", "pre-kindergarten")
  );
  const querySnapshot = await getDocs(q);

  const delCollection = querySnapshot.docs.map(async (doc) => {
    await updateDoc(doc.ref, {
      className: "kindergarten one",
    });
    // await deleteDoc(doc.ref);
  });
  await Promise.all(delCollection);
  console.log("Updated Succssfully!!");
  console.log("\n");

  // await updateDoc(doc(db, `class/${classID}`), {
  //   [`pupils.${studYear}`]: deleteField(),
  // });
};
